import { Menu, Transition } from '@headlessui/react';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { Avatar } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/store';
import classNames from 'classnames';
import { IsSuperAdmin } from 'shared/permissions/IsSuperAdmin';
import { logout } from 'store';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

const UserMenuDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.auth.user);

  const userNavigation = [
    {
      name: 'Settings',
      handle: () => {
        navigate('/tenant/settings');
      }
    },
    {
      name: 'Sign out',
      handle: () => {
        dispatch(logout());
      }
    }
  ];

  return (
    <Menu as="div" className="relative ml-1 z-50">
      <div>
        <Menu.Button className="flex items-center justify-center rounded-full focus:outline-none transition-all duration-150 border-2 border-transparent hover:border-slate-200 active:scale-95">
          <Avatar
            alt={user ? `Avatar di ${user}` : 'Avatar Utente'}
            sx={{
              bgcolor: '#6c757d',
              color: '#ffffff',
              width: 28,
              height: 28,
              borderRadius: '50% !important',
              '& img': {
                borderRadius: '50% !important',
                objectFit: 'cover'
              },
              '& .MuiAvatar-fallback, & .MuiAvatar-img, &': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontSize: '12px',
                fontWeight: 600,
                fontStyle: 'normal',
                lineHeight: '100%',
                letterSpacing: '0%'
              }
            }}>
            {user && user.trim().length > 0 ? user.trim().substring(0, 2).toUpperCase() : 'OP'}
          </Avatar>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-150"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-100"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-52 rounded-xl bg-white shadow-[0_10px_30px_-5px_rgba(0,0,0,0.1),0_8px_16px_-8px_rgba(0,0,0,0.1)] border border-slate-100 focus:outline-none overflow-hidden p-1">
          {/* SETTINGS */}
          <IsSuperAdmin>
            <Menu.Item>
              {({ active }) => (
                <button
                  type="button"
                  onClick={userNavigation[0].handle}
                  className={classNames(
                    active ? 'bg-slate-50' : 'bg-transparent',
                    'flex items-center w-full px-4 py-3 rounded-lg transition-colors text-left focus:outline-none group'
                  )}>
                  <SettingsIcon
                    sx={{ color: '#6c757d', fontSize: '22px' }}
                    className="mr-4 flex-shrink-0 transition-transform duration-200 group-hover:rotate-45"
                  />
                  <span className="font-sans text-[16px] font-medium text-[#0f2d4a] tracking-tight">
                    {userNavigation[0].name}
                  </span>
                </button>
              )}
            </Menu.Item>
          </IsSuperAdmin>

          {/* LINEA DIVISORIA SOTTILE */}
          <div className="my-1 border-t border-slate-100 mx-3"></div>

          {/* LOGOUT */}
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={userNavigation[1].handle}
                className={classNames(
                  active ? 'bg-red-50/50' : 'bg-transparent',
                  'flex items-center w-full px-4 py-3 rounded-lg transition-colors text-left focus:outline-none'
                )}>
                <LogoutIcon
                  sx={{ color: '#f14b24', fontSize: '22px' }}
                  className="mr-4 flex-shrink-0"
                />
                <span className="font-sans text-[16px] font-medium text-[#f14b24] tracking-tight">
                  Logout
                </span>
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default UserMenuDropdown;
